module.exports = __webpack_public_path__ + "img/mitera_logo.ebe029e7.svg";